import GeoJsonCesiumParser from "../entity-parser/GeoJsonCesiumParser";
import { updateEntityHeight } from "../height-update/heightUpdateUtil";
import * as Cesium from "cesium";
import { DataSource, DataSourceCollection } from "cesium";
import Layers from "../../../../MapStore2/web/client/utils/cesium/Layers";
import { Wfs3dLayer } from "../../types";

export const WFS_3D_LAYER_IDENTIFIER = "wfs3d";

type WfsOptions = {
    data: Wfs3dLayer[];
    reloadWfs3dLayers: boolean;
    onCesiumStateChange: Function;
    wfsDataLoaded: boolean;
    shouldUpdate: boolean;
    adjustedHeight: number;
};

const getDataSourceNames = (dataSources: DataSourceCollection) => {
    const names = [];
    for (let i = 0; i < dataSources.length; i++) {
        names.push(dataSources.get(i).name);
    }
    return names;
};

function loadDataSources(map: Cesium.Viewer, newOptions: WfsOptions) {
    if (newOptions.reloadWfs3dLayers) {
        map.dataSources.removeAll();
    }
    const loadedDataSourcesNames = getDataSourceNames(map.dataSources);
    const dataSourcesToAdd = newOptions.data
        .filter((ds) => !loadedDataSourcesNames.includes(ds.name))
        .map((data) => GeoJsonCesiumParser.parse(data.features, data.name));

    if (dataSourcesToAdd.length > 0) {
        dataSourcesToAdd.map((ds: Promise<DataSource>) => map.dataSources.add(ds));
    }
}

Layers.registerType(WFS_3D_LAYER_IDENTIFIER, {
    create: (options: WfsOptions, map: Cesium.Viewer) => {
        if (options.data?.filter((layer) => layer.visible).length < 1) {
            map.dataSources.removeAll();
        }
        return null;
    },
    update: function (layer: any, newOptions: WfsOptions, oldOptions: WfsOptions, map: Cesium.Viewer) {
        if (newOptions.data || newOptions.reloadWfs3dLayers) {
            loadDataSources(map, newOptions);

            for (let index = 0; index < map.dataSources.length; index++) {
                const dataSource = map.dataSources.get(index);
                const newLayers = newOptions.data.map((layer) => {
                    return { name: layer.name, features: layer.filteredFeatures, visible: layer.visible };
                });
                Promise.resolve(dataSource).then(function () {
                    const newLayer = newLayers.filter((layer) => layer.name === dataSource.name)[0];
                    const filteredIds = newLayer.features;
                    const visible = newLayer.visible;

                    if (filteredIds) {
                        for (const entity of dataSource.entities.values) {
                            entity.show = visible && filteredIds.includes((entity as any)._properties.featureId);
                            if (newOptions.shouldUpdate && newOptions.adjustedHeight) {
                                updateEntityHeight(entity, newOptions.adjustedHeight);
                            }
                        }
                    }
                });
            }
        }

        return null;
    },
});
